// extracted by mini-css-extract-plugin
module.exports = {"Header":"HomepageHeader-Header-2lAL2r","Logo":"HomepageHeader-Logo-3-xOT0","HomeLink":"HomepageHeader-HomeLink-31yM8Z"};